import { useQuery } from 'react-query';
import { RemotePhsPstApplyRepo } from '@repository/phs/pst/apply/PhsPstApplyRepo';
import { ProgressStatusList } from '@domain/constant/phsProgressType';

const keys = ['phs', 'pst', 'apply'];
const PSTApplyStatusKeys = [...keys, 'applyStatus'];

const remotePHSApplyRepo = new RemotePhsPstApplyRepo();

const fetchPSTMaxApplyCount = async () => {
  const { data } = await remotePHSApplyRepo.fetchPSTMaxApplyCount();
  return data.maxApplyChance;
};

const fetchPSTApplyStatus = async () => {
  const { data } = await remotePHSApplyRepo.fetchPSTApplyStatus();

  //진행중인지 판단
  const isProgress = ProgressStatusList.includes(data.lastApplyStatus?.progressType ?? '');

  return {
    ...data,
    isProgress,
  };
};

function usePSTMaxApplyCount() {
  return useQuery([...keys, 'pst', 'maxCount'], fetchPSTMaxApplyCount);
}

function usePSTApplyStatus(isEnabled: boolean) {
  return useQuery(PSTApplyStatusKeys, fetchPSTApplyStatus, {
    enabled: isEnabled,
    refetchOnWindowFocus: true,
  });
}

export { keys as phsPstApplyKeys, PSTApplyStatusKeys, usePSTMaxApplyCount, usePSTApplyStatus };
